import request from '../infra/request';
import { StatusCodes } from 'http-status-codes';
import { STATUS } from '../constants';
import { buildPatientAuthorizationHeader } from '../utils/patientAccessStorage';

const { SUCCESS, FAILURE } = STATUS;

export const bookAppointment = async (data) => {
  try {
    const result = await request.post('/api/appointment/booking', data);
    const { status } = result;

    if (status === StatusCodes.CREATED) {
      return {
        status: SUCCESS,
      };
    }

    return {
      status: FAILURE,
      error: 'Can not book appointment',
    };
  } catch (e) {
    return {
      status: FAILURE,
      error: `Can not book appointment, error: ${e}`,
    };
  }
};

export const deleteAppointment = async (workflowId) => {
  try {
    const result = await request.delete(
      `/api/appointment/booking/${workflowId}`,
      { headers: buildPatientAuthorizationHeader(workflowId) }
    );
    const { status } = result;

    if (status === StatusCodes.OK) {
      return {
        status: SUCCESS,
      };
    }

    return {
      status: FAILURE,
      error: 'Can not delete appointment',
    };
  } catch (e) {
    return {
      status: FAILURE,
      error: `Can not delete appointment, error: ${e}`,
    };
  }
};

export const recordPaymentConsent = async (data) => {
  try {
    const result = await request.post(
      '/api/appointment/payment-consent',
      data,
      { headers: buildPatientAuthorizationHeader(data.workflowId) }
    );
    const { status } = result;

    if (status === StatusCodes.CREATED) {
      return {
        status: SUCCESS,
      };
    }

    return {
      status: FAILURE,
      error: 'Can not record payment consent',
    };
  } catch (e) {
    return {
      status: FAILURE,
      error: `Can not record payment consent, error: ${e}`,
      httpStatus: e?.response?.status,
    };
  }
};

export const rescheduleAppointment = async (
  workflowId,
  { start, timezone, cover }
) => {
  try {
    const { data } = await request.patch(
      `/api/appointment/booking/${workflowId}/reschedule`,
      { start, timezone, ...(cover ? { cover } : {}) },
      { headers: buildPatientAuthorizationHeader(workflowId) }
    );

    return { status: SUCCESS, data: data?.data };
  } catch (e) {
    return {
      status: FAILURE,
      errorCode: e?.response?.data?.error,
      errorDetail: e?.response?.data?.detail,
      httpStatus: e?.response?.status,
    };
  }
};
